import { useTranslation } from 'react-i18next';
import { gtmEvent, getGtmTagValue } from '../../../utils/gtmEvents';

export const PaymentFrequencyLabel = (frequency, toLowerCase = false) => {
  const { t } = useTranslation();
  if (!frequency) return null;

  const paymentFrenuency = {
    paymentFrequencyMonthly: t('Shared.Common.PaymentFrequency.monthly'),
    paymentFrequencyBiWeekly: t('Shared.Common.PaymentFrequency.biWeekly'),
    paymentFrequencyWeekly: t('Shared.Common.PaymentFrequency.weekly'),
  };

  const label = {
    weekly: `${paymentFrenuency.paymentFrequencyWeekly}`,
    biweekly: `${paymentFrenuency.paymentFrequencyBiWeekly}`,
    monthly: `${paymentFrenuency.paymentFrequencyMonthly}`,
  };

  return toLowerCase ? label[frequency].toLowerCase() : label[frequency];
};

export const generateTermOptions = financeOptions =>
  financeOptions?.map(option => ({
    value: option,
    text: option,
  }));

export const generateFinanceOptions = financeOptions =>
  financeOptions?.map(option => ({
    value: option,
    text: PaymentFrequencyLabel(option, false),
  }));

export const pushGtmFinanceOptions = (gtmPayment, gtmTerm, gtmModel) => {
  const gtmPayload = {
    event: 'finance_update',
    financing_payment: getGtmTagValue(gtmPayment),
    financing_term: getGtmTagValue(gtmTerm),
    model: getGtmTagValue(gtmModel),
  };
  gtmEvent(gtmPayload);
};
